/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
// @ts-nocheck
$(document).ready(function(){
    $('addons-slider-top-wrapper, addons-slider-chair-wrapper').each(function () {
        var $addonsWrapper = $(this);
        var $addonsSlider = $addonsWrapper.find('addons-slider');
        var $addonsNextBtn = $addonsWrapper.find('.top-addons-nav_arrow[data="next"]');
        var $addonsPrevBtn = $addonsWrapper.find('.top-addons-nav_arrow[data="prev"]');
        var $addonsShadowRight = $addonsWrapper.find('.top-addons-wrapper__side_shadow.right');
        var $addonsShadowLeft = $addonsWrapper.find('.top-addons-wrapper__side_shadow.left');

        function getCardScrollOffset(/** @type {jQuery} */ $card) {
            return $card[0].getBoundingClientRect().left - $addonsSlider[0].getBoundingClientRect().left + $addonsSlider[0].scrollLeft;
        }

        function updateAddonsNav() {
            var scrollLeft = $addonsSlider[0].scrollLeft;
            var maxScroll = $addonsSlider[0].scrollWidth - $addonsSlider[0].clientWidth;
            var atStart = scrollLeft <= 1;
            var atEnd = scrollLeft >= maxScroll - 1;

            $addonsPrevBtn.toggleClass('disabledNav', atStart);
            $addonsShadowLeft.toggleClass('disabledNav', atStart);
            $addonsNextBtn.toggleClass('disabledNav', atEnd);
            $addonsShadowRight.toggleClass('disabledNav', atEnd);
        }

        function onAddonsNextClick() {
            var scrollLeft = $addonsSlider[0].scrollLeft;
            var nextCard = null;

            $addonsWrapper.find('top-addon-card, addon-chair-card').each(function () {
                var offset = getCardScrollOffset($(this));
                if (offset > scrollLeft + 2 && !nextCard) {
                    nextCard = $(this);
                }
            });

            if (nextCard) {
                $addonsSlider[0].scrollTo({ left: getCardScrollOffset(nextCard), behavior: 'smooth' });
            }
        }

        function onAddonsPrevClick() {
            var scrollLeft = $addonsSlider[0].scrollLeft;
            var prevCard = null;

            $addonsWrapper.find('top-addon-card, addon-chair-card').each(function () {
                var offset = getCardScrollOffset($(this));
                if (offset < scrollLeft - 2) {
                    prevCard = $(this);
                }
            });

            if (prevCard) {
                $addonsSlider[0].scrollTo({ left: getCardScrollOffset(prevCard), behavior: 'smooth' });
            }
        }

        $addonsNextBtn.on('click', onAddonsNextClick);
        $addonsPrevBtn.on('click', onAddonsPrevClick);
        $addonsSlider.on('scroll', updateAddonsNav);
        updateAddonsNav();

        $addonsSlider[0].addEventListener('wheel', function (/** @type {WheelEvent} */ e) {
            if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
                e.preventDefault();
                $addonsSlider[0].scrollLeft += e.deltaX;
            }
        }, { passive: false });

        $addonsWrapper.find('.tac-color-option_scroller__outer').each(function () {
            var $outer = $(this);
            var $swatchScroller = $outer.find('.tac-color-option_scroller');
            var $swatchNextBtn = $outer.find('.tac-option_scroller.next');
            var $swatchPrevBtn = $outer.find('.tac-option_scroller.prev');
            var $swatchShadowNext = $outer.find('.tac-option_scroller-shadow.next');
            var $swatchShadowPrev = $outer.find('.tac-option_scroller-shadow.prev');

            if (!$swatchNextBtn.length) return;

            function updateSwatchNav() {
                var scrollLeft = $swatchScroller[0].scrollLeft;
                var maxScroll = $swatchScroller[0].scrollWidth - $swatchScroller[0].clientWidth;
                var atStart = scrollLeft <= 1;
                var atEnd = scrollLeft >= maxScroll - 1;

                $swatchPrevBtn.toggleClass('disabledNav', atStart);
                $swatchShadowPrev.toggleClass('disabledNav', atStart);
                $swatchNextBtn.toggleClass('disabledNav', atEnd);
                $swatchShadowNext.toggleClass('disabledNav', atEnd);
            }

            $swatchNextBtn.on('click', function (e) {
                e.stopPropagation();
                $swatchScroller[0].scrollTo({ left: $swatchScroller[0].scrollLeft + 50, behavior: 'smooth' });
            });

            $swatchPrevBtn.on('click', function (e) {
                e.stopPropagation();
                $swatchScroller[0].scrollTo({ left: $swatchScroller[0].scrollLeft - 50, behavior: 'smooth' });
            });

            $swatchScroller.on('scroll', updateSwatchNav);
            updateSwatchNav();

            $swatchScroller[0].addEventListener('wheel', function (/** @type {WheelEvent} */ e) {
                if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
                    e.preventDefault();
                    e.stopPropagation();
                    $swatchScroller[0].scrollLeft += e.deltaX;
                }
            }, { passive: false });
        });

        // Preload all variant images on first hover over the slider
        $addonsWrapper.one('mouseenter', function () {
            $addonsWrapper.find('.addon_config-data').each(function () {
                var src = $(this).attr('data-image');
                if (src) {
                    var img = new Image();
                    img.src = src;
                }
            });
        });
    });

    // Changing/preselecting addons

    $('.tac-color-swatch').click(function(e){
        if ($(this).hasClass('tac_disabled')) { e.stopPropagation(); return; }
        $(this).closest('.tac-variants').find('.tac-color-swatch').removeClass('add_active');
        $(this).addClass('add_active');
        var productId = $(this).attr('data-product-id');
        var $context = $(this).closest('.ac_upsell, top-addon-card, addon-chair-card');
        getAddonAdata(productId, $context, $(this));
    });

    $('.tap-option_line-value').click(function(e){
        // Standard/Pro toggle pills reuse this styling class but are driven by
        // their own handler (.addon-toggle-line) — skip the variant-config logic.
        if ($(this).closest('.addon-toggle-line').length) return;
        if ($(this).hasClass('tac_disabled')) { e.stopPropagation(); return; }
        $(this).closest('.tac-variants').find('.tap-option_line-value').removeClass('add_active');
        $(this).addClass('add_active');
        var productId = $(this).attr('data-product-id');
        var $context = $(this).closest('.ac_upsell, top-addon-card, addon-chair-card');
        getAddonAdata(productId, $context, $(this));
    });

    function getAddonAdata(productId, $context, $clicked){
        var newTitle = '';
        $context.find('.addon_config-option-sel[data-product-id="' + productId + '"].add_active').each(function(){
            var thisTitle = $(this).attr('data-title') || $(this).attr('data-value');
            newTitle = newTitle + '-' + thisTitle;
        });
        newTitle = newTitle.substring(1);

        var $configData = $context.find('.addon_config-data[data-product-id="'+productId+'"][data-title="'+newTitle+'"]');
        console.log('[Addons] productId:', productId, 'newTitle:', '"'+newTitle+'"', 'configData found:', $configData.length > 0);
        if ($clicked) {
            console.log('[Addons] clicked mmq-code:', '"'+($clicked.attr('data-mmq-code')||'')+'",', 'mmq-block:', '"'+($clicked.attr('data-mmq-block')||'')+'"');
        }
        var discount = parseInt($configData.attr('data-discount')) || 0;
        var hasDiscount = discount > 0;
        var $imgTarget = $([]);

        if ($context.is('addon-chair-card')) {
            var $info = $context.find('.ac_content-info');
            $info.find('real-price[data-chair-price]').text($configData.attr('data-price-chair'));
            $info.find('compare-price[data-chair-original-price]').text($configData.attr('data-price')).toggle(!hasDiscount);
            $info.find('compare-price[data-chair-compare-price]').text($configData.attr('data-compare')).toggle(hasDiscount);
            // Discount = saving vs the FULL compare price (compare-at when on sale, else the
            // original price), measured against the chair price. Chairs ALWAYS carry the 5%
            // chair saving, so the badge shows even without a variant sale (`chairHasDiscount`,
            // not `hasDiscount`). Own % so percent-mode works without a variant discount.
            var chairCardWas = window.deskPriceToNumber($configData.attr('data-compare')) > window.deskPriceToNumber($configData.attr('data-price'))
                ? $configData.attr('data-compare')
                : $configData.attr('data-price');
            var chairWasNum = window.deskPriceToNumber(chairCardWas);
            var chairPriceNum = window.deskPriceToNumber($configData.attr('data-price-chair'));
            var chairPct = chairWasNum > 0 ? Math.round((chairWasNum - chairPriceNum) / chairWasNum * 100) : 0;
            $info.find('price-discount').text(window.deskDiscountBadge(chairPct, $configData.attr('data-price-chair'), chairCardWas)).toggle(chairWasNum > chairPriceNum);
            $imgTarget = $context.find('.ac_content-media img');
        } else if ($context.is('.ac_upsell')) {
            var $upsellContent = $context.find('.ac_upsell-content');
            $upsellContent.find('real-price').text($configData.attr('data-price'));
            $upsellContent.find('compare-price').text($configData.attr('data-compare')).toggle(hasDiscount);
            $upsellContent.find('price-discount').text(window.deskDiscountBadge(discount, $configData.attr('data-price'), $configData.attr('data-compare'))).toggle(hasDiscount);
            $imgTarget = $context.find('.ac_upsell-media__image img');
        } else {
            $context.find('real-price').text($configData.attr('data-price'));
            $context.find('compare-price').text($configData.attr('data-compare')).toggle(hasDiscount);
            $context.find('price-discount').text(window.deskDiscountBadge(discount, $configData.attr('data-price'), $configData.attr('data-compare'))).toggle(hasDiscount);
            $imgTarget = $context.find('.top-addon-card-image img');
        }

        var newSrc = $configData.attr('data-image');
        var swapImg = new Image();
        swapImg.onload = function () {
            $imgTarget.attr('src', newSrc);
        };
        swapImg.src = newSrc;

        if ($clicked) {
            var $mainInput = $context.children('input.addOneMainInput__js');
            if ($mainInput.length) {
                $mainInput.attr('data-variant-id', $configData.attr('data-id') || '');
                var mmqCode = $configData.attr('data-mmq-code') || $clicked.attr('data-mmq-code') || '';
                var mmqBlock = $configData.attr('data-mmq-option') || $clicked.attr('data-mmq-block') || '';
                $mainInput.attr('data-mmq-code', mmqCode);
                $mainInput.attr('data-mmq-option', mmqBlock);
                console.log('[Addons] input set - code:', '"'+mmqCode+'",', 'option:', '"'+mmqBlock+'"');
                $mainInput.trigger('change');
            }
        }
    }

    // Within a top-addon-card-line, only one card may be active at a time
    // (e.g. monitor holder vs monitor riser). Standalone cards are untouched.
    // IMPORTANT: call this AFTER the newly activated card has fired its own
    // "show" change, so the new model wins the mmQisLoading mutex first.
    function deactivateAddonCardLineSiblings($card) {
        var $line = $card.closest('top-addon-card-line');
        if (!$line.length) return;
        var activeBlock = $card.children('input.addOneMainInput__js').attr('data-mmq-block') || '';
        $line.find('top-addon-card.activated').not($card).each(function () {
            var $sibling = $(this);
            $sibling.removeClass('activated');
            var $siblingInput = $sibling.children('input.addOneMainInput__js');
            if (!$siblingInput.length) return;
            var siblingBlock = $siblingInput.attr('data-mmq-block') || '';
            // Same MMQ block: activating the new card already replaced the old
            // model in that block. Sending the sibling's hide-code would clear
            // the new model too, so only update the UI here.
            if (siblingBlock && siblingBlock === activeBlock) return;
            // Different block: hide the old model, but only after the new card's
            // "show" command has run — overlapping commands get dropped by the
            // mmQisLoading mutex in desk_pdp-mimeeq.js.
            setTimeout(function () {
                $siblingInput.attr('data-mmq-toggle', 'off');
                $siblingInput.trigger('change');
            }, 700);
        });
    }

    // Reflect whether any card in a top-addon-card-line-box is active.
    function syncAddonCardLineBox($card) {
        var $box = $card.closest('top-addon-card-line-box');
        if (!$box.length) return;
        $box.toggleClass('activated', $box.find('top-addon-card.activated').length > 0);
    }

    $('top-addon-card').click(function(e){
        // The Standard/Pro toggle lives inside .tac-variants; its clicks must not
        // activate (add to cart) the card — they only switch the shown product.
        if ($(e.target).closest('.addon-toggle-line').length) return;
        if ($(this).hasClass('disabledAddon')) return;
        if ($(e.target).closest('.tac__details').length) {
            return;
        }
        if ($(e.target).closest('.tac-color-option_scroller__outer').length || $(e.target).closest('.tap-option_line').length) {
            var wasActivated = $(this).hasClass('activated');
            $(this).addClass('activated');
            if (!wasActivated) {
                var $mainInput = $(this).children('input.addOneMainInput__js');
                if ($mainInput.length) {
                    $mainInput.attr('data-mmq-toggle', 'on');
                    $mainInput.trigger('change');
                }
            }
            deactivateAddonCardLineSiblings($(this));
            syncAddonCardLineBox($(this));
            return;
        }
        $(this).toggleClass('activated');
        var isNowActive = $(this).hasClass('activated');
        var $mainInput = $(this).children('input.addOneMainInput__js');
        if ($mainInput.length) {
            $mainInput.attr('data-mmq-toggle', isNowActive ? 'on' : 'off');
            $mainInput.trigger('change');
        }
        if (isNowActive) {
            deactivateAddonCardLineSiblings($(this));
        }
        syncAddonCardLineBox($(this));
    });

    // Standard / Pro toggle (desk_product-toggle-addone). The pill is the product
    // SELECTOR: clicking it shows that product AND makes it the active addon, so
    // its 3D model / colours / price become the selected ones. The other product
    // is turned off. Both cards share one top-addon-card-line.
    $(document).on('click', '.addon-toggle-line .tap-option_line-value', function () {
        var $box = $(this).closest('.addon-toggle-box');
        var target = $(this).attr('data-toggle-target');

        // Keep the toggle in sync on BOTH cards (each card has its own copy).
        $box.find('.addon-toggle-line .tap-option_line-value').removeClass('add_active');
        $box.find('.addon-toggle-line .tap-option_line-value[data-toggle-target="' + target + '"]').addClass('add_active');

        // Show the chosen product's panel, hide the other.
        var $panels = $box.find('.addon-toggle-panel');
        var $targetPanel = $box.find('.addon-toggle-panel[data-toggle-panel="' + target + '"]');
        $panels.removeClass('is-active');
        $targetPanel.addClass('is-active');

        var $targetCard = $targetPanel.find('top-addon-card').first();
        var $otherCard = $panels.not($targetPanel).find('top-addon-card').first();
        if (!$targetCard.length || $targetCard.hasClass('activated')) return;

        var otherWasActive = $otherCard.length && $otherCard.hasClass('activated');

        // Activate the shown product (enables its 3D + selection). Fire this FIRST
        // so its model wins the mmQisLoading mutex before any hide command.
        $targetCard.addClass('activated');
        var $targetInput = $targetCard.children('input.addOneMainInput__js');
        if ($targetInput.length) {
            $targetInput.attr('data-mmq-toggle', 'on');
            $targetInput.trigger('change');
        }

        // If the other product was active, hand off from it. The shared helper
        // hides the old model (skips the hide when both share an MMQ block, so
        // the new model isn't cleared) with the correct 700ms mutex timing.
        if (otherWasActive) {
            deactivateAddonCardLineSiblings($targetCard);
        }
        syncAddonCardLineBox($targetCard);
    });

    function deactivateChairCard($card, isSwitch) {
        $card.removeClass('activated');
        $card.find('.ac_upsell').slideUp();
        var $upsellBox = $card.find('.ac_upsell-box');
        var wasUpsellActive = $upsellBox.hasClass('activated');
        setTimeout(function () {
            $upsellBox.removeClass('activated');
        }, 1000);

        if (isSwitch) {
            // New chair selected — let its activation replace the model, don't hide this one.
            // If wheels were active, hide them after 1500ms once the new chair has loaded.
            if (wasUpsellActive) {
                var $upsellInput = $card.find('.ac_upsell').children('input.addOneMainInput__js');
                setTimeout(function () {
                    if ($upsellInput.length) {
                        $upsellInput.attr('data-mmq-toggle', 'off');
                        $upsellInput.trigger('change');
                    }
                }, 1500);
            }
        } else {
            var $mainInput = $card.children('input.addOneMainInput__js');
            if ($mainInput.length) {
                $mainInput.attr('data-mmq-toggle', 'off');
                $mainInput.trigger('change');
            }
        }
    }

    function deactivateChairCards($except) {
        $('addon-chair-card.activated').not($except).each(function () {
            deactivateChairCard($(this), true);
        });
    }

    function centerChairCardInSlider($card) {
        var $slider = $card.closest('addons-slider-chair-wrapper').find('addons-slider');
        if (!$slider.length) return;
        var sliderEl = $slider[0];
        var cardRect = $card[0].getBoundingClientRect();
        var sliderRect = sliderEl.getBoundingClientRect();
        var isFullyVisible = cardRect.left >= sliderRect.left && cardRect.right <= sliderRect.right;
        if (!isFullyVisible) {
            var cardOffset = cardRect.left - sliderRect.left + sliderEl.scrollLeft;
            var targetScroll = cardOffset + $card[0].offsetWidth / 2 - sliderEl.clientWidth / 2;
            sliderEl.scrollTo({ left: targetScroll, behavior: 'smooth' });
        }
    }

    $('addon-chair-card').click(function(e){
        if ($(e.target).closest('.tac__details').length) {
            return;
        }
        if ($(e.target).closest('.ac_upsell').length) {
            return;
        }
        var $card = $(this);
        if ($(e.target).closest('.tac-color-option_scroller__outer').length || $(e.target).closest('.tap-option_line').length) {
            if (!$card.hasClass('activated')) {
                deactivateChairCards($card);
                $card.addClass('activated');
                $card.find('.ac_upsell').slideDown();
                centerChairCardInSlider($card);
                var $mainInput = $card.children('input.addOneMainInput__js');
                if ($mainInput.length) {
                    $mainInput.attr('data-mmq-toggle', 'on');
                    $mainInput.trigger('change');
                }
            }
            return;
        }
        var wasActivated = $card.hasClass('activated');
        deactivateChairCards($card);
        if (wasActivated) {
            deactivateChairCard($card);
        } else {
            $card.addClass('activated');
            $card.find('.ac_upsell').slideDown();
            centerChairCardInSlider($card);
            var $mainInput = $card.children('input.addOneMainInput__js');
            if ($mainInput.length) {
                $mainInput.attr('data-mmq-toggle', 'on');
                $mainInput.trigger('change');
            }
        }
    });

    $('.ac_upsell-box').click(function(e){
        if ($(e.target).closest('.tac__details').length) {
            return;
        }
        if ($(e.target).closest('.tac-color-option_scroller__outer').length || $(e.target).closest('.tap-option_line').length) {
            var wasActivated = $(this).hasClass('activated');
            $(this).addClass('activated');
            if (!wasActivated) {
                var $mainInput = $(this).closest('.ac_upsell').children('input.addOneMainInput__js');
                if ($mainInput.length) {
                    $mainInput.attr('data-mmq-toggle', 'on');
                    $mainInput.trigger('change');
                }
            }
            return;
        }
        $(this).toggleClass('activated');
        var $mainInput = $(this).closest('.ac_upsell').children('input.addOneMainInput__js');
        if ($mainInput.length) {
            $mainInput.attr('data-mmq-toggle', $(this).hasClass('activated') ? 'on' : 'off');
            $mainInput.trigger('change');
        }
    });

    function preselectChairAddonFromUrl() {
        var variantId = '';
        var open3d = false;
        var params;
        var $data;
        var $card;
        var $swatch;

        try {
            params = new URLSearchParams(window.location.search);
            variantId = params.get('addon') || '';
            open3d = params.get('open3d') === '1';
        } catch (e) {
            return;
        }

        if (!/^\d+$/.test(variantId)) return;

        $data = $('addon-chair-card .addon_config-data[data-id="' + variantId + '"]').filter(function () {
            return !$(this).closest('.ac_upsell').length;
        }).first();

        if (!$data.length) return;

        $card = $data.closest('addon-chair-card');
        $swatch = $card.find('.tac-color-swatch[data-product-id="' + $data.attr('data-product-id') + '"][data-value="' + $data.attr('data-title') + '"]').filter(function () {
            return !$(this).closest('.ac_upsell').length;
        }).first();

        if ($swatch.length) {
            if ($swatch.hasClass('tac_disabled')) return;
            $swatch.trigger('click');
        } else if (!$card.hasClass('activated')) {
            $card.trigger('click');
        }

        if (open3d && $card.hasClass('activated')) openAddon3dView();
    }

    function openAddon3dView() {
        if (window.innerWidth < 767) return;

        setTimeout(function () {
            if (window.mmqShowed) return;
            $('[is-3d-opener]').first().trigger('click');
        }, 300);
    }

    preselectChairAddonFromUrl();
});